module.exports = __webpack_public_path__ + "static/media/create_entity.956393cc.png";